<template>
    <v-list
        ><v-list-item v-for="user in relationships" :key="user.id">
            <SoliStudent
                :student="user"
                @input="$emit('input', user)"
                :hasPaymentMethod="!!user.pm_last_four"
            />
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        relationships: {
            type: Array,
            default() {
                return [];
            },
        },
    },
};
</script>

<style></style>
